import { z } from 'my-zod'
import { TimeZoneEnum } from '../../internal/timezone'
import { ProgramNameEnum } from '../../internal/program-name'

export const operatorTimeZoneView = z.object({
  id: z.number(),
  shortId: z.string(),
  groupId: z.number(),
  businessName: z.string().nullable(),
  programName: ProgramNameEnum,
  dealerNumber: z.string().nullable(),
  billingAccountId: z.string().nullable(),
  timezone: TimeZoneEnum.nullable()
})

export type operatorTimeZoneView = z.infer<typeof operatorTimeZoneView>
